import { ReusableWizard } from "@oysterhr/feature-components"
import { StripeSepaWrapper } from "../../SepaFlowPage/components/StripeSepaWrapper"
import { NewBankDetailsForm } from "../components/NewBankDetailsForm"
import { PaymentEngagementType } from "../../../../enums"

export const BankDetailsStepContractor = () => {
  return (
    <ReusableWizard.Step title="Add payment method" subtitle="Next: Authorize Direct Debit">
      <StripeSepaWrapper>
        <NewBankDetailsForm paymentType={PaymentEngagementType.Contractor} />
      </StripeSepaWrapper>
    </ReusableWizard.Step>
  )
}
